import React from 'react'
import "./Our_Features.css"
import faq_trut from "../Assets/faq_turtle.png"
import l_roc from "../Assets/left_roc.png"
import r_roc from "../Assets/r_roc.png"
import fea from "../Assets/feaure_one.png"
import { IoIosArrowRoundForward } from "react-icons/io";

export default function Our_Features() {
  return (
    <section className='main_our_feature overflow-hidden position-relative' id='Features'>
        <div className="container">
            <h1 className='section_head gor_font text-center mt-4 mt-md-1' data-aos="fade-up" >Our Features </h1>
            <div className="row z-2 position-relative" style={{marginTop:"3rem"}}>
                <div className="col-md-4" data-aos="fade-right">
                    <div className="feature_box">
                        <div>
                            <img src={fea} className='w-100 rbsjh' style={{height:"150px ",}} alt="" />
                        </div>
                        <h6 className='fea_head  z-2 position-relative fw-bold mt-3 nor_font text-start fs-2' >Content Creation Events</h6>
                        <p className='feature_para  z-2 position-relative text-white nor_font fs-6'>Engage in weekly, monthly, and annual content creation events to earn rewards within our communit</p>
                    {/* <button className='Red_btn fw-bold mt-md-5 mt-lg-1 nor_font'>Buy Now <IoIosArrowRoundForward className=' text-white fs-2' /></button> */}
                    </div>

                </div>
                <div className="col-md-8" data-aos="fade-left">
                    <div className="row">
                        <div className="col-md-6 mt-3 mt-md-0">
                        <div className="feature_box right_fea">
                      
                        <h6 className='fea_head fw-bold mt-3 nor_font text-start text-md-center fs-2' >Long-Term Community Rewards</h6>
                        <p className='feature_para text-white nor_font  text-md-center fs-6'>Stay active and involved for a chance to receive long-term recognition and rewards.</p>
                    </div>
                        </div>
                        <div className="col-md-6 mt-3 mt-md-0">
                        <div className="feature_box right_fea">
                      
                        <h6 className='fea_head fw-bold mt-3 nor_font text-start text-md-center fs-2' >Free Tournaments</h6>
                        <p className='feature_para text-white nor_font  text-md-center fs-6'>Participate in free tournaments regularly and earn coins without any entry fee.</p>
                    </div>
                        </div>
                        <div className="col-md-6 mt-3 ">
                        <div className="feature_box right_fea">
                      
                        <h6 className='fea_head fw-bold mt-3 nor_font text-start text-md-center fs-2' >Wagering System</h6>
                        <p className='feature_para text-white nor_font  text-md-center fs-6'>Choose your game, set a wager, and compete to win, with all wagers securely managed until the winner is decided.</p>
                    </div>
                        </div>
                        <div className="col-md-6 mt-3 ">
                        <div className="feature_box right_fea">
                      
                        <h6 className='fea_head fw-bold mt-3 nor_font text-start text-md-center fs-2' >Eco-Friendly Staking</h6>
                        <p className='feature_para text-white nor_font  text-md-center fs-6'>By choosing staking over mining, we reduce environmental impact while increasing coin value and supporting blockchain security.</p>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img src={faq_trut} className='faq_tur' alt="" />
        <img src={l_roc} className='d-none d-md-block l_roc' style={{width:"600px",top:"-5%"}} alt="" />
            <img src={r_roc} className='d-none d-md-block r_roc' style={{bottom:"-50%"}} alt="" />
    </section>
  )
}
